import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupAction } from '@coin/importer/core/util';
import { TransferListEntryDto, TransferListEntryOrigin } from '@coin/importer/dto/util';
import { Subscription } from 'rxjs';
import { TransferListService } from '../../../services/organisation-management/transfer-list.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'importer-transfer-list-entry-popup',
  templateUrl: './transfer-list-entry-popup.component.html',
  styleUrls: ['./transfer-list-entry-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TransferListEntryPopupComponent {
  matDialogRef = inject<MatDialogRef<TransferListEntryPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private toast = inject(ToastService);
  transferListService = inject(TransferListService);

  Action = PopupAction;
  entryList = this.data['entryList'] as TransferListEntryDto[];
  originalItem = this.data['item'] as TransferListEntryDto;
  action = this.data['action'] as PopupAction;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  origin: string[] = Object.values(TransferListEntryOrigin);
  uploading = false;
  uploadSubscription: Subscription;

  constructor() {
    if (this.data['action'] === PopupAction.New) {
      this.item = {
        Gid: '',
        SourceOrgCode: '',
        TargetOrgCode: '',
        Origin: TransferListEntryOrigin.BUS2
      };
    } else {
      this.item = this.originalItem;
    }
  }

  async create() {
    if (this.validate()) {
      this.trimStringFields();
      await this.transferListService.createEntry(this.item);
    }
    this.transferListService.setTemporaryLog(this.item);
    this.close();
  }

  async update() {
    if (this.validate()) {
      this.trimStringFields();
      await this.transferListService.updateEntry(this.item);
    }
    this.close();
  }

  async delete() {
    if (this.validate()) {
      await this.transferListService.deleteEntry(this.item.Gid);
    }
    this.close();
    window.location.reload();
  }

  close() {
    if (this.uploading) {
      this.cancelUpload();
    } else {
      this.matDialogRef.close();
    }
  }

  private cancelUpload() {
    this.uploadSubscription?.unsubscribe();
    this.uploading = false;
    this.toast.info('Upload cancelled');
  }

  validate(): boolean {
    for (const [k] of Object.entries(this.item).filter(([k]) => k !== 'SourceOrgCode')) {
      if (!this.item[k]) {
        return false;
      }
    }
    return true;
  }

  validateString(str: string): string | null {
    if (!str) {
      return 'cannot be empty';
    }
    if (str && !str.match(/([A-Za-z0-9]+( [A-Za-z0-9]+)?)/i)) {
      return 'has invalid characters';
    }
    return null;
  }

  trimStringFields() {
    this.item.Gid = this.item.Gid.trim();
    this.item.SourceOrgCode = this.item.SourceOrgCode.trim();
    this.item.TargetOrgCode = this.item.TargetOrgCode.trim();
  }
}
